export interface FilterLocation {
  id: string;
  name: string;
}

export interface FilterShift {
  id: string;
  name: string;
}

export const REPORT_LOCATIONS: FilterLocation[] = [
  { id: 'all', name: 'Todos los locales' },
  { id: 'loc-1', name: 'Macartur Centro' },
  { id: 'loc-2', name: 'Macartur Molina 02' },
  { id: 'loc-3', name: 'Macartur Benavides 03' },
  { id: 'loc-4', name: 'Macartur Panama 04' }
];

export const REPORT_SHIFTS: FilterShift[] = [
  { id: 'all', name: 'Todos los turnos' },
  { id: 'MAÑANA', name: 'Mañana' },
  { id: 'TARDE', name: 'Tarde' }
];